module.exports = __webpack_public_path__ + "images/illustrations/illustration-files-978c832c9888948bcf231a3d907f0763.webp";